import {combineReducers} from 'redux'
import {createPivotTableReducer} from 'reducers/pivotTable'

export const partContentsPivotTableKey = 'priceListsContext.part.partContents.pivotTable'

export default combineReducers({
      pivotTable: createPivotTableReducer({key: partContentsPivotTableKey, defaultSortColumn: 'order'}),
    }
)
